@if (tip(); as tip) {
    <div
        class="flex items-center gap-y-16 text-text"
        [attr.data-testid]="tip.testId"
        [ngClass]="hasCTAs() ? 'gap-x-8' : 'gap-x-16'"
    >
        @if (tip.alertIcon) {
            <interacta-icon
                class="size-24 shrink-0 text-text-error"
                [icon]="'warning'"
            />
        } @else if (imageSrc()) {
            <img alt="" class="size-80 shrink-0" [src]="imageSrc()" />
        }

        <div class="min-w-0 grow wrap-break-word">
            @if (tip.title) {
                <p
                    class="mb-4 typo-t6"
                    [innerHTML]="tip.title | translate: tip.translateParams"
                    [ngClass]="{
                        'pl-12': hasCTAs(),
                    }"
                ></p>
            }
            <div
                class="flex"
                [ngClass]="{
                    'flex-col': tip.direction === 'vertical',
                    'w-full justify-between': tip.direction === 'horizontal',
                }"
            >
                @if (tip.message | apply: asString; as message) {
                    <div
                        class="typo-sm whitespace-pre-line"
                        [innerHtml]="message | translate: tip.translateParams"
                        [ngClass]="{
                            'pl-12': hasCTAs(),
                        }"
                    ></div>
                } @else if (tip.message | apply: asDelta; as deltaMessage) {
                    <interacta-delta-view
                        class="min-w-0 typo-sm break-all whitespace-pre-line"
                        [delta]="deltaMessage"
                        [iconSize]="'small'"
                        [ngClass]="{
                            'pl-12': hasCTAs(),
                        }"
                    />
                }

                @if (tip.actionCallbacks.length) {
                    <div class="mt-4 flex flex-wrap gap-x-8 gap-y-4">
                        @for (
                            actionCallback of tip.actionCallbacks;
                            track actionCallback.action.id
                        ) {
                            <button
                                class="overflow-hidden whitespace-nowrap"
                                interacta-button
                                type="button"
                                [label]="
                                    actionCallback.action.label
                                        | translate
                                        | uppercase
                                "
                                [size]="'small'"
                                [style]="'text-primary'"
                                (click)="actionClicked.emit(actionCallback)"
                            ></button>
                        }
                    </div>
                }
            </div>
        </div>
        @if (!tip?.hideCloseButton) {
            <button
                class="ml-auto shrink-0"
                interacta-icon-button
                type="button"
                [icon]="'close'"
                [label]="'UI.BUTTON.CLOSE' | translate"
                [size]="'regular'"
                [style]="'text'"
                [tooltipClass]="'tooltip-reverse-theme'"
                (click)="closeTip.emit()"
            ></button>
        }
    </div>
}
